import { exportPrivateCryptoKeyToPem } from '@lucidlink/ts-crypto/crypto';
import { isNil } from '@lucidlink/tscore';
import { Logging } from '#common/logging';
export function createPrincipalCryptoProvider(idService, userCrypto) {
    return new PrincipalCryptoProviderImpl(idService, userCrypto);
}
class PrincipalCryptoProviderImpl {
    idService;
    userCrypto;
    log = Logging.getLogger('PrincipalCryptoProvider');
    constructor(idService, userCrypto) {
        this.idService = idService;
        this.userCrypto = userCrypto;
    }
    async getCryptoKeys() {
        this.log.debug('Fetching groups crypto...');
        const principalsCrypto = await this.getGroupsCrypto();
        this.log.debug('Groups crypto fetched.');
        const adminCrypto = this.getAdminCrypto(principalsCrypto);
        const isAdminUser = !isNil(adminCrypto);
        if (isAdminUser) {
            return { principalCrypto: [adminCrypto], isAdmin: isAdminUser };
        }
        principalsCrypto.push(this.userCrypto);
        return { principalCrypto: principalsCrypto, isAdmin: isAdminUser };
    }
    async getGroupsCrypto() {
        const userInfo = await this.idService.getGroupsPrivateKeys();
        const groupKeys = userInfo.privateKeys;
        const result = [];
        for (const groupId of Object.keys(groupKeys)) {
            result.push({
                principalId: groupId,
                decryptedPrivateRsaKeyPem: await exportPrivateCryptoKeyToPem(groupKeys[groupId]),
            });
        }
        return result;
    }
    getAdminCrypto(principalsCrypto) {
        const adminGroupId = this.idService.getAdminGroupId();
        const adminCrypto = principalsCrypto.find((principalCrypto) => {
            return principalCrypto.principalId === adminGroupId;
        });
        return adminCrypto;
    }
}
